// extracted by mini-css-extract-plugin
export default {"container":"suggestion_container__SLiCn"};